import * as Basic_ping_request_atd$SolvuuApi0 from "./basic_ping_request_atd.bs.js";
var entity = "basic";

function path(param) {
  return (
    /* :: */
    ["ping",
    /* [] */
    0]
  );
}

function body(param) {
  return (
    /* None */
    870530776
  );
}

function info(param, param$1) {
  return (
    /* () */
    0
  );
}

var $$Request = {
  Json: Basic_ping_request_atd$SolvuuApi0.Json,
  json_of_info: Basic_ping_request_atd$SolvuuApi0.json_of_info,
  info_of_json: Basic_ping_request_atd$SolvuuApi0.info_of_json,
  path: path,
  body: body,
  info: info
};
var Ping = {
  entity: entity,
  service: "Basic.Ping",
  $$Request: $$Request,
  $$Response:
  /* alias */
  0
};
export { entity, Ping };
/* No side effect */